import error from "../pages/404";

// route level code-splitting
// this generates a separate chunk (about.[hash].js) for this route
// which is lazy-loaded when the route is visited.

export default [
  {
    path: "/",
    meta: { title: "Login" },
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../pages/LoginPage.vue"),
  },
  {
    path: "/zapier-auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/AuthorizeZapierPage"),
  },
  {
    path: "/integration-auth",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/IntegrationAuthPage"),
  },
  {
    path: "/validate-account",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/ValidateAccount"),
  },
  {
    path: "/sign-up",
    meta: { title: "Sign Up" },
    component: () =>
      import(/* webpackChunkName: "register" */ "../pages/RegisterAccountPage"),
  },
  {
    path: "/email-validated",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/EmailValidatedPage"),
  },
  {
    path: "/email-not-validated",
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/EmailNotValidatedPage"),
  },
  {
    path: "/sign-up/appsumo",
    meta: { title: "Sign Up" },
    component: () =>
      import(/* webpackChunkName: "register" */ "../pages/RegisterAccountPage"),
  },
  {
    path: "/forgot-password",
    meta: { title: "Forgot Password" },
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/ForgotPasswordPage"),
  },
  {
    path: "/update-password",
    meta: { title: "Update Password" },
    component: () =>
      import(
        /* webpackChunkName: "auth" */ "../pages/UpdatePasswordViaLinkPage"
      ),
  },
  {
    path: "/accept-invite",
    meta: { title: "Accept Invite" },
    component: () =>
      import(/* webpackChunkName: "auth" */ "../pages/AcceptInvitePage"),
  },
  {
    path: "/overview",
    meta: { title: "Overview" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/OverviewPage"),
  },
  {
    path: "/dashboard",
    redirect: "/overview",
  },
  {
    path: "/proof-archive",
    meta: { title: "Proofs" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofArchivePage"),
  },
  {
    path: "/proof-list",
    meta: { title: "Proofs" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofListPage"),
  },
  {
    path: "/proof-item",
    meta: { title: "Proof" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofItemPage"),
  },
  {
    path: "/proof-details",
    meta: { title: "Proof" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProofDetailsPage"),
  },
  {
    path: "/knowledge-base",
    meta: { title: "Knowledge Base" },
    component: () =>
      import(/* webpackChunkName: "knowledge-base" */ "../pages/KnowledgeBasePage"),
  },
  {
    path: "/knowledge-base-article",
    meta: { title: "Knowledge Base" },
    component: () =>
      import(/* webpackChunkName: "knowledge-base" */ "../pages/KnowledgeBaseArticlePage"),
  },
  {
    path: "/contact-archive",
    meta: { title: "Contacts" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ApproverArchivePage"),
  },
  {
    path: "/approver-item",
    meta: { title: "Contact" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ApproverItemPage"),
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: "/contact-details",
    meta: { title: "Contact" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ContactDetailsPage"),
    props: (route) => ({ id: route.query.id }),
  },
  {
    path: "/workflows",
    meta: { title: "Workflows" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/WorkflowsPage"),
  },
  {
    path: "/email-templates",
    meta: { title: "Email Templates" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/EmailTemplatesPage"),
  },
  {
    path: "/checklists",
    meta: { title: "Checklists" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ChecklistsPage"),
  },
  {
    path: "/automation-archive",
    redirect: "/workflows",
  },
  {
    path: "/preflights",
    meta: { title: "Preflights" },
    component: () =>
      import(
        /* webpackChunkName: "internal" */ "../pages/PreflightsPage"
      ),
  },
  {
    path: "/workflow-item",
    meta: { title: "Workflow" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/WorkflowItem"),
  },
  {
    path: "/template-item",
    meta: { title: "Email Template" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/TemplateItemPage"),
  },
  {
    path: "/profile",
    meta: { title: "Profile" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ProfilePage"),
  },
  {
    path: "/account",
    meta: { title: "Account" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/AccountPage"),
  },
  {
    path: "/mcp",
    component: () => import(/* webpackChunkName: "internal" */ "../pages/McpPage"),
  },
  {
    path: "/users",
    meta: { title: "Users" },
    component: () =>
        import(/* webpackChunkName: "internal" */ "../pages/UsersPage"),
  },
  {
    path: "/billing",
    meta: { title: "Billing" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/BillingPage"),
  },
  {
    path: "/cancel",
    meta: { title: "Billing" },
    component: () => 
      import(/* webpackChunkName: "internal" */ "../pages/BillingPage"),
  },
  {
    path: "/create",
    meta: { title: "Create" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/CreatePage"),
  },
  {
    path: "/create-proof",
    meta: { title: "Create Proof" },
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/CreateProofPage"),
  },
  {
    path: "/thanks",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ThankYou"),
  },
  {
    path: "/success",
    component: () =>
      import(/* webpackChunkName: "internal" */ "../pages/ThankYou"),
  },
  {
    path: "/compare/*",
    component: () =>
        import(/* webpackChunkName: "external" */ "../pages/ComparePage"),
  },
  {
    path: "/review/*",
    component: () =>
        import(/* webpackChunkName: "external" */ "../pages/ReviewPage.router"),
  },
  {
    path: "/captains-deck",
    meta: { title: "Captain's Deck" },
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeck"),
  },
  {
    path: "/captains-deck/health",
    meta: { title: "Account Health" },
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeckHealth"),
  },
  {
    path: "/captains-deck/review/:accountId",
    meta: { title: "Business Review" },
    component: () =>
      import(/* webpackChunkName: "93939" */ "../pages/CaptainsDeckReview"),
  },
  {
    path: "/onboarding",
    meta: { title: "Onboarding" },
    component: () =>
      import(/* webpackChunkName: "onboarding" */ "../pages/Onboarding.vue"),
  },
  {
    path: "/jobs",
    meta: { title: "Jobs" },
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobList.vue"),
  },
  {
    path: "/jobs/report",
    meta: { title: "Jobs Report" },
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobReport.vue"),
  },
  {
    path: "/job-details/:id",
    meta: { title: "Job" },
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobDetails.vue"),
  },
  {
    path: "/job-status",
    meta: { title: "Job Status" },
    component: () =>
      import(/* webpackChunkName: "jobs" */ "../pages/JobStatus.vue"),
  },
  {
    path: "/artwork-intake",
    meta: { title: "Artwork Intake" },
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeList.vue"),
  },
  {
    path: "/files",
    meta: { title: "Files" },
    component: () =>
      import(/* webpackChunkName: "files" */ "../pages/FilesList.vue"),
  },
  {
    path: "/artwork-intake/submission/:id",
    meta: { title: "Submission" },
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeDetails.vue"),
    props: true,
  },
  {
    path: "/artwork-intake/settings",
    meta: { title: "Artwork Intake Settings" },
    component: () =>
      import(/* webpackChunkName: "artwork-intake" */ "../pages/ArtworkIntakeSettings.vue"),
  },
  {
    path: "/artwork-intake-form/:formId",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/ArtworkIntakeFormPublic.vue"),
  },
  {
    path: "/portal/:accountPublicId",
    alias: "/portal/:accountPublicId/login",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/PortalLoginPage.vue"),
  },
  {
    path: "/portal/:accountPublicId/proofs",
    component: () =>
      import(/* webpackChunkName: "external" */ "../pages/PortalProofsPage.vue"),
  },
  {
    path: "/403",
    component: () => import(/* webpackChunkName: "auth" */ "../pages/UnAuth"),
  },
  { path: "*", component: error }, //must be last
];

//https://router.vuejs.org/guide/essentials/navigation.html
